import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="11" height="11" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M4.086 5.5L.293 1.707A1 1 0 111.707.293L5.5 4.086 9.293.293a1 1 0 011.414 1.414L6.914 5.5l3.793 3.793a1 1 0 11-1.414 1.414L5.5 6.914l-3.793 3.793A1 1 0 11.293 9.293L4.086 5.5z" fill="#5781be" fillRule="evenodd" /></svg>;